import { 
  faDesktop, 
  faRobot, 
  faUser, 
  faCog 
} from '@fortawesome/free-solid-svg-icons';

// Step type definitions - Core 4 step types only
export const STEP_TYPES = {
  UI_TEMPLATE: {
    type: 'UITemplate',
    icon: faDesktop,
    color: 'from-green-500 to-emerald-500',
    label: 'UI Entry Point',
    description: 'Workflow entry point waiting for template form submissions'
  },
  AI: {
    type: 'AI',
    icon: faRobot,
    color: 'from-purple-500 to-pink-500',
    label: 'AI Step',
    description: 'Execute AI prompts and process responses'
  },
  HUMAN: {
    type: 'Human',
    icon: faUser,
    color: 'from-blue-500 to-cyan-500',
    label: 'Human Step',
    description: 'Require human intervention or approval'
  },
  BACKEND: {
    type: 'Backend',
    icon: faCog,
    color: 'from-gray-600 to-slate-600',
    label: 'Backend Step',
    description: 'Execute server-side code with success/failure routing'
  }
};

// Valid step types array for validation
export const VALID_STEP_TYPES = Object.values(STEP_TYPES).map(type => type.type);

// Step validation rules
export const STEP_VALIDATION_RULES = {
  AI: {
    required: ['provider', 'provider_api', 'prompt_id'],
    optional: ['selected_tools']
  },
  UITemplate: {
    required: ['entry_point_name', 'api_route'],
    optional: ['redirect_type', 'redirect_url', 'description']
  },
  Human: {
    required: ['role', 'task_type'],
    optional: ['timeout_hours', 'escalation_action']
  },
  Backend: {
    required: ['function'],
    optional: ['parameters']
  }
};

// Default step configuration templates
export const DEFAULT_STEP_CONFIGS = {
  AI: {
    provider: '',
    provider_api: '',
    prompt_id: '',
    selected_tools: []
  },
  UITemplate: {
    entry_point_name: '',
    api_route: '',
    redirect_type: 'workflow_chat',
    auto_redirect: true
  },
  Human: {
    role: '',
    task_type: '',
    timeout_hours: 24,
    escalation_action: ''
  },
  Backend: {
    function: '',
    parameters: {}
  }
};

// Import/Export constants
export const IMPORT_SUPPORTED_FIELDS = [
  'name', 
  'type', 
  'config', 
  'actionRouting', 
  'transitions', 
  'on'
];

// Action routing constants
export const SPECIAL_TARGETS = {
  END: 'end',
  ERROR: 'error'
};